export const DEFAULT_TIMEOUT_MS = 30_000;
export const MAX_RETRIES = 3;
export const SUPPORTED_PLATFORMS = ["web", "ios", "android"] as const;
export * from "./analytics-headers";
export * from "./application-instructions";
export * from "./auth-cookies";
export * from "./billing";
export * from "./integration-branch";
export * from "./pipeline-labels";
